<template>
    <div class="page">
        <div class="renew">
            <!-- 战绩榜 轮播 -->
            <div class="top-stock-list swiper2" v-show="top_list.length > 0">
                <div class="swiper-container">
                    <div class="swiper-wrapper swiper-no-swiping">
                        <div
                            class="swiper-slide"
                            v-for="(item, i) in top_list"
                            :key="'rank_' + i"
                        >
                            <span
                                class="top-stock-list-item"
                                :data-stock="item.code"
                                :data-name="item.name"
                                @click="onClickStock(item)"
                            >{{ item.text }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="div">
                <p>根据大数据多维度选出正处于上升趋势，成交量和市场关注度较高，中线热门题材，主流机构和量化资金抱团的活跃股。</p>
                <!-- <p>产品证书号：A0690621010001</p> -->
            </div>

            <button id="unLock" @click="unlock">查看今日股票池 只需20金币</button>
        </div>

        <!-- 去 App 登录提示弹窗 -->
        <div class="download_app_pop" v-if="toastVisible" @click="toastVisible = false">
            <div class="download_app_content2" @click.stop>
                <p>需要前往app登录才能继续<span>查看</span></p>
                <div class="download_btn_wrap">
                    <a href="javascript:;" class="download_btn_l" @click="toastVisible = false">
                        取消
                    </a>
                    <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui" class="download_btn_r">
                        立即跳转
                    </a>
                </div>
            </div>
        </div>

        <!-- 入选详情弹窗 -->
        <div class="tanc_w" v-show="show_tip">
            <div class="tanc">
                <svg @click="show_tip = false;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.63402 4.3513L15.9314 15.6487M4.06833 15.6487L15.3657 4.3513" stroke="#888888" stroke-width="1.6" stroke-linecap="round"/>
                </svg>
                <p class="tanc_fb margin8">{{show_data.stock_name}}（{{show_data.symbol}}）</p>
                <p class="margin8">现价：<span class="tanc_red">{{show_data.last_price}}  +{{show_data.chg_pct}}%</span> </p>
                <p class="margin8">30天入选：<span class="tanc_red">{{show_data.select_number}}次</span> </p>
                <div class="ckhq tanc_red2" @click="goDetail({
                    code: show_data.code,
                    name: show_data.stock_name,
                })">
                    查看行情
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none">
                        <path d="M1.37971 9.82031L5.62028 5.37953L1.37971 1.17969" stroke="#FF443D" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="rxls">
                    <div class="r_l"></div>
                    <span class="tanc_fb span">入选历史</span>
                    <div class="r_l"></div>
                </div>

                <div class="rxls_box">
                    <div class="rxls_item">
                        <span class="tanc_c63">入选时间</span>
                        <span class="tanc_c63">历史推荐</span>
                    </div>
                    <div class="rxls_item" v-for="(item, i) in show_data.list" :key="'history_' + i">
                        <span>{{item.date_ymd}}</span>
                        <span class="tanc_b" @click="showHistory(item);">
                            {{ not_vip && dateStr.includes(item.date_ymd) ? '开通后查看' : '查看' }}
                        </span>
                    </div>
                </div>

                <div class="kt_btn" v-if="not_vip" @click="openPay">
                    立即开通
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
    name: "stockPoolUnlock",
    data() {
        return {
            // 是否 H5 落地（分享链接）：无 Authorization 参数即落地，需先拿登录态
            isH5: false,
            // 是否已登录（H5 模式下通过 H5ReactUserCenter 判断）
            isLogin: false,
            // 请求头 token：内嵌模式从 query 读取，H5 模式登录后拼接 Bearer
            Authorization: this.getQueryVariable('Authorization') ? decodeURI(this.getQueryVariable('Authorization')) : '',
            // 战绩榜数据
            top_list: [],
            swiper2: null,
            // 接口返回的最新日期（用于「开通后查看」判断）
            dateStr: '',
            // 去 App 登录提示弹窗
            toastVisible: false,
            // 入选详情弹窗
            show_tip: false,
            show_data: {},
            not_vip: false,
            // 是否已购买（is_vip == "yes" 已购买，否则未购买）
            is_vip: '',
        }
    },
    computed: {
        // 环境前缀：dev/beta/正式
        envPre() {
            let host = location.host;
            if (host.indexOf('dev') != -1) {
                return 'dev';
            } else if (host.indexOf('beta') != -1) {
                return 'beta';
            }
            return '';
        }
    },
    created() {
        // 内嵌（带 Authorization）直接拉数据；落地（无 Authorization）先拿登录态
        if (this.Authorization) {
            this.isH5 = false;
            this.get_dateStr();
        } else {
            this.isH5 = true;
            this.getLoginInfo();
        }
    },
    methods: {
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) { return pair[1]; }
            }
            return '';
        },
        // 落地页：拿登录态，取 user_app_token 拼 Bearer
        getLoginInfo() {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                dataType: 'json',
                url: `https://mobile${_this.envPre}.aigupiao.com/H5ReactUserCenter/index?Agp-Super-Project=1`,
                cache: false,
                async: true,
                error: function () { return false; },
                success: function (res) {
                    if (res.data && res.data.user_app_token) {
                        _this.isLogin = true;
                        _this.Authorization = "Bearer " + res.data.user_app_token;
                    }
                    _this.get_dateStr();
                }
            })
        },
        // 点击解锁按钮
        unlock() {
            if (this.isH5) {
                if (this.isLogin) {
                    // 已登录：若已购买，直接跳购买后列表页；否则提示去 App 登录/购买
                    if (this.is_vip == "yes") {
                        location.href = "/up/h5/stockPool";
                    } else {
                        this.toastVisible = true;
                    }
                } else {
                    location.href = "/login/index/rd/980880418.html?redirect=" + encodeURIComponent(location.href);
                }
                return;
            }
            // 内嵌（APP）模式：拼接支付协议
            let _str = "_str=stockPool#AiGuPiao_ThirdPay";
            if (location.href.indexOf('?') > -1) {
                location.href += ('&' + _str);
            } else {
                location.href += ('?' + _str);
            }
        },
        // 主数据：判断是否 VIP，VIP 直接跳购买后列表页
        get_dateStr() {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'post',
                dataType: 'json',
                url: `https://app${_this.envPre}.aigupiao.com/goapi/stock/get_stock_pool`,
                cache: false,
                async: true,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                error: function () { return false; },
                success: function (res) {
                    _this.dateStr = res.data && res.data.update_time;
                    _this.is_vip = res.data && res.data.is_vip;
                    if (res.data && res.data.is_vip == "yes") {
                        location.href = "/up/h5/stockPool";
                        return;
                    }
                },
                complete: function () {
                    _this.getTopData();
                }
            })
        },
        // 战绩榜轮播信息
        getTopData() {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                dataType: 'json',
                url: `https://api${_this.envPre}.stock-ring.com/goapi/stock/stock_pool_rank`,
                cache: false,
                async: true,
                error: function () { return false; },
                success: function (res) {
                    _this.top_list = res.data || [];
                    _this.swiper();
                }
            })
        },
        swiper() {
            // 战绩榜 滚动事件
            if (this.swiper2) {
                // 清除已有滚动
                this.swiper2.destroy(true);
            }
            if (this.top_list.length > 1) {
                this.$nextTick(() => {
                    this.swiper2 = new Swiper(".swiper-container", {
                        observer: true, // 修改 swiper 自己或子元素时，自动初始化 swiper
                        observeParents: true, // 修改 swiper 的父元素时，自动初始化 swiper
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                        },
                        loop: true,
                        direction: 'vertical',
                    });
                });
            }
        },
        // 点击轮播里的股票
        onClickStock(item) {
            if (this.Authorization) {
                this.openDetail(item.code);
            } else {
                location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=${item.code}&name=${item.name}`;
            }
        },
        // 股票详情弹窗数据
        openDetail(stock) {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                dataType: 'json',
                url: `https://app${_this.envPre}.aigupiao.com/goapi/stock/get_stock_pool_detail`,
                cache: false,
                async: true,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                data: { stock: stock },
                error: function () { return false; },
                success: function (res) {
                    if (res.code == 1) {
                        _this.show_tip = true;
                        _this.show_data = res.data;
                        _this.not_vip = res.data.is_vip == 'no' ? true : false;
                        _this.show_data.code = stock;
                    }
                }
            })
        },
        // 跳转行情详情页
        goDetail(item) {
            location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=${item.code}&name=${item.name}`;
        },
        showHistory(item) {
            // 判断日期是否是最新时间
            if (this.not_vip && this.dateStr.includes(item.date_ymd)) {
                this.openPay();
            } else {
                this.checkDate(item.date_ymd);
            }
        },
        // 跳转购买后列表页（查看历史）
        checkDate(date) {
            this.show_tip = false;
            location.href = `/up/stockPool?Authorization=${this.Authorization}&kind=QSJX&date=${date}`;
        },
        // 立即开通（支付）
        openPay() {
            let _str = "_str=stockPool#AiGuPiao_ThirdPay";
            if (location.href.indexOf('?') > -1) {
                location.href += ('&' + _str);
            } else {
                location.href += ('?' + _str);
            }
        }
    }
}
</script>

<style scoped lang="scss">
* {
    margin: 0;
    padding: 0;
    letter-spacing: 1px;
}

a {
    text-decoration: none;
    color: #1D88D0;
}

.page {
    min-height: 100vh;
    position: relative;
    background-color: transparent;
    background-image: url("https://cdncos.aigupiao.com/assets/wap/img/stockPool/bg_2.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
}

.renew {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    bottom: 15%;
    padding: 0 47px;
    box-sizing: border-box;
}

.renew > .div {
    width: 100%;
    height: auto;
    padding: 10px 15px;
    background-color: #FF8E57;
    border: 1px solid #FFF3E2;
    box-sizing: border-box;
    margin-bottom: 0;
    border-radius: 10px;
}

.renew > .div > p {
    font-size: 12px;
    line-height: 16px;
    color: #FFFBEC;
}

.renew > .div > p:first-of-type {
    margin-bottom: 8px;
}

.renew > button {
    width: 100%;
    height: 63px;
    background-color: transparent;
    background-image: url("https://cdncos.aigupiao.com/assets/wap/img/stockPool/button_1.png");
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center center;
    border: none;
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    user-select: none;
}

.swiper2 {
    width: 100%;
    margin: 0 0 12px;
    height: 38px;
    background: linear-gradient(180deg, #FFEDE3 0%, #FFD6C3 100%);
    border-radius: 8px;
    opacity: 0.98;
    border: 1px solid rgba(255, 255, 255, 0.82);
    font-size: 14px;
    font-weight: 400;
    color: #FF5117;
    overflow: hidden;
}

.swiper2 .swiper-container {
    height: 100%;
}

.swiper2 .swiper-slide {
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.top-stock-list-item {
    display: flex;
    align-items: center;
    padding-left: 44px;
    font-size: 14px;
    font-weight: 400;
    color: #FF5117;
    background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/top-stock-list-item.png) no-repeat;
    background-size: 15px 11px;
    background-position: 10px center;
    position: relative;
    height: 100%;
    max-width: 100%;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &::before {
        content: "";
        display: block;
        position: absolute;
        width: 1px;
        height: 19px;
        background: #E8E8E8;
        top: 50%;
        left: 33px;
        transform: translateY(-50%);
    }
}

.tanc_w {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 20px;
    color: #333;
}

.tanc {
    width: 265px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 3px solid #EDD8A9;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%), linear-gradient(180deg, #F7E4C8 0%, #FFF 44.33%);
    padding: 24px;
    box-sizing: border-box;
    position: relative;
}

.tanc > svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    position: absolute;
    top: 16px;
    right: 16px;
}

.tanc_red {
    color: #CB382D;
}

.tanc_red2 {
    color: #FF443D;
}

.tanc_c63 {
    color: #636363;
}

.tanc_b {
    color: #1D88D0;
}

.tanc_f13 {
    font-size: 13px;
}

.tanc_fb {
    font-weight: bold;
}

.ckhq {
    display: flex;
    width: 220px;
    height: 31px;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    flex-shrink: 0;
    border-radius: 21px;
    border: 1px solid #FF443D;
}

.ckhq > svg {
    width: 6px;
    height: 12px;
    flex-shrink: 0;
    margin-left: 6px;
}

.margin8 {
    margin-bottom: 8px;
}

.rxls {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 17px 0;
}

.tanc_fb.span {
    margin: 0 10px;
}

.r_l {
    width: 50px;
    height: 1px;
    background: #EBEBEB;
    background-blend-mode: plus-darker;
}

.rxls_item {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.kt_btn {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    height: 36px;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    flex-shrink: 0;
    border-radius: 21px;
    background: linear-gradient(180deg, #EB8057 0%, #EC5E3A 100%);
    color: #FFF;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.download_app_pop {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);
}

.download_app_content2 {
    border-radius: 11px;
    background: #FFF;
    display: flex;
    width: 252px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.download_app_content2 > p {
    color: #333;
    font-size: 15px;
    padding: 18px 14px;
    line-height: 1.5;
}

.download_btn_wrap {
    display: flex;
    width: 100%;
    border-top: 0.5px solid #EBEBEB;
}

.download_btn_wrap > a {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #636363;
    font-size: 14px;
    height: 41px;
    width: 50%;
}

.download_btn_wrap .download_btn_r {
    color: #FE484A;
    border-left: 0.5px solid #EBEBEB;
}
</style>
